import React from 'react'

export interface FilterChipProps {
  /** The text content to display in the chip */
  label: string
  /** Callback when the close button is clicked */
  onRemove?: () => void
  /** Maximum width for the label before truncation (default: 180px) */
  maxWidth?: number
  /** Additional class names */
  className?: string
}

export function FilterChip({ label, onRemove, maxWidth = 180, className = '' }: FilterChipProps) {
  return (
    <span
      className={`inline-flex items-center gap-2 px-2 py-1 bg-[rgba(159,159,248,0.3)] rounded-full text-sm font-medium text-tokens-neutral-text-primary ${className}`}
    >
      <span className='overflow-hidden text-ellipsis whitespace-nowrap' style={{ maxWidth }}>
        {label}
      </span>
      {onRemove && (
        <button
          type='button'
          onClick={e => {
            e.stopPropagation()
            onRemove()
          }}
          className='flex-shrink-0 text-tokens-neutral-text-primary hover:opacity-70 transition-opacity'
          aria-label={`Remove ${label}`}
        >
          <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M12.5 3.5L3.5 12.5M3.5 3.5L12.5 12.5'
              stroke='currentColor'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </button>
      )}
    </span>
  )
}

export default FilterChip
